import {MediaImage, MediaType} from "../types";
import InvalidApiV4ResponseError from "../Errors/InvalidApiV4ResponseError";

import {
    ListWidgetExperienceMediaResponseDataInner
} from "@bookingkit/api-v4/models/list-widget-experience-media-response-data-inner";

export const fromApiExperienceMedia = (expMedia: ListWidgetExperienceMediaResponseDataInner): MediaImage => {
    if(typeof expMedia.id !== 'string') {
        throw InvalidApiV4ResponseError.fromMissingProperty('id', 'string', expMedia.id);
    }
    const description = 'description' in expMedia
        ? (expMedia.description?.map(d => ({ locale: d.locale ?? '', text: d.text ?? '' })) ?? [])
        : [];
    return {
        id: expMedia.id,
        sort: 'sort' in expMedia ? expMedia.sort : undefined,
        sizes: 'sizes' in expMedia ? expMedia.sizes : undefined,
        type: expMedia.type as MediaType,
        description,
    }
}